(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[134],{

/***/ 830:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news",
      function () {
        return __webpack_require__(4139);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ NewsListPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1046);
/* harmony import */ var _components_sections_teaser_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4531);
/* harmony import */ var _components_sections_page_title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3810);
/* harmony import */ var _components_sections_rich_text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2639);
/* harmony import */ var _components_seo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4169);
/* harmony import */ var _lib_date__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9960);
/* harmony import */ var _lib_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(608);
/* harmony import */ var _components_pagination__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(889);
/* harmony import */ var _components_container__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2606);










var __N_SSP = true;
function NewsListPage(param) {
    let { news , menu , menuFooter , menuFooterSecondary , pagination , settings , url  } = param;
    var _settings_texts;
    var _settings_texts_newsTitle;
    const title = (_settings_texts_newsTitle = (_settings_texts = settings.texts) === null || _settings_texts === void 0 ? void 0 : _settings_texts.newsTitle) !== null && _settings_texts_newsTitle !== void 0 ? _settings_texts_newsTitle : "News";
    var _settings_texts_noNews;
    const renderNoNews = ()=>{
        var _settings_texts;
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sections_rich_text__WEBPACK_IMPORTED_MODULE_4__["default"], {
            data: {
                html: "<p>".concat((_settings_texts_noNews = (_settings_texts = settings.texts) === null || _settings_texts === void 0 ? void 0 : _settings_texts.noNews) !== null && _settings_texts_noNews !== void 0 ? _settings_texts_noNews : "There are no news currently.", "</p>")
            }
        });
    };
    var _settings_texts_read;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        menu: menu,
        menuFooter: menuFooter,
        menuFooterSecondary: menuFooterSecondary,
        settings: settings,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_seo__WEBPACK_IMPORTED_MODULE_5__/* .Seo */ .p, {
                    url: url,
                    title: title,
                    seo: null
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sections_page_title__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    data: {
                        title
                    }
                }),
                news.length === 0 ? renderNoNews() : news.map((post, index)=>{
                    var _settings_texts;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sections_teaser_text__WEBPACK_IMPORTED_MODULE_2__["default"], {
                        data: {
                            ...post,
                            layout: index % 2 > 0 ? "ImageRight" : "ImageLeft",
                            subTitle: (0,_lib_date__WEBPACK_IMPORTED_MODULE_6__/* .parseDate */ .s)(post.publishDate),
                            link: {
                                text: (_settings_texts_read = (_settings_texts = settings.texts) === null || _settings_texts === void 0 ? void 0 : _settings_texts.read) !== null && _settings_texts_read !== void 0 ? _settings_texts_read : "Read",
                                url: "/news/".concat(post.slug)
                            },
                            paragraph: null
                        },
                        fixedHeight: true
                    }, post.id);
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_container__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    size: _lib_types__WEBPACK_IMPORTED_MODULE_7__/* .ContainerSize.wide */ .B.wide,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagination__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        ...pagination
                    })
                })
            ]
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [446,46,966,774,888,179], function() { return __webpack_exec__(830); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);